export const VERSIONCHECK_PROTOCOL = 'VERSIONCHECK_PROTOCOL';